import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { ShieldCheck, Zap } from 'lucide-react';
export function Mechanism() {
  return <section className="py-24 px-4 bg-white relative overflow-hidden" data-id="element-210">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-sage/30 rounded-full blur-3xl pointer-events-none" data-id="element-211" />

      <div className="max-w-3xl mx-auto relative z-10" data-id="element-212">
        <FadeIn data-id="element-213">
          <div className="text-center mb-12" data-id="element-214">
            <span className="text-amber font-bold tracking-wider uppercase text-sm mb-4 block" data-id="element-215">
              El Mecanismo Único
            </span>
            <h2 className="font-serif text-3xl sm:text-4xl font-bold text-forest mb-6" data-id="element-216">
              El Protocolo de Resincronización Nutricional (Nutri-Sync)
            </h2>
          </div>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-217">
          <div className="prose prose-lg text-charcoal/80 mx-auto" data-id="element-218">
            <p className="mb-6 leading-relaxed" data-id="element-219">
              A diferencia de los estimulantes que te dan un "subidón"
              artificial, este método identifica las{' '}
              <strong data-id="element-220">3 fugas de energía principales</strong> (Magnesio,
              Complejo B y Electrolitos) y las sella sistemáticamente.
            </p>

            <div className="bg-forest text-offwhite p-8 rounded-2xl shadow-xl my-10 relative overflow-hidden" data-id="element-221">
              <div className="absolute top-0 right-0 opacity-10 transform translate-x-1/4 -translate-y-1/4" data-id="element-222">
                <Zap size={200} data-id="element-223" />
              </div>
              <div className="relative z-10 flex items-start gap-4" data-id="element-224">
                <ShieldCheck className="text-amber shrink-0 mt-1" size={32} data-id="element-225" />
                <p className="text-xl font-medium leading-relaxed m-0" data-id="element-226">
                  No inyectamos energía falsa; restauramos la capacidad natural
                  de tus células para generar su propio combustible, eliminando
                  la niebla mental desde la raíz.
                </p>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}